import React, { FC, ReactNode } from 'react';

interface IShowMoreItem {
  data: string | ReactNode[];
}

export const ShowMoreItem: FC<IShowMoreItem> = ({ data }) => {
  if (typeof data === 'string') {
    return <span dangerouslySetInnerHTML={{ __html: data }} />;
  }

  return <>{data.map((item) => item)}</>;
};
